export default __webpack_public_path__ + "static/media/01.27.25 Minutes Reg Mtg.67c70ee0.pdf";